import { Mailbox } from 'components'
import { ViewAuthorizer } from 'components/AccessDenied'
import { UserRole } from 'model'
import * as React from 'react'

export const MailboxView: React.FC<{}> = () => {
  return <Mailbox />
}

export const MailboxViewAuthorized: React.FC<{}> = () => {
  return (
    <ViewAuthorizer
      roles={[
        UserRole.SystemAdministrator,
        UserRole.ResourceManager,
        UserRole.ServiceTeam,
        UserRole.ProvingOrganisation,
        UserRole.Hrg,
      ]}
    >
      <Mailbox />
    </ViewAuthorizer>
  )
}
